import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { CustomWarningConfig } from '../modal.service';
import { SharedModule } from '../../shared.module';

@Component({
  selector: 'fs-custom-warning',
  imports: [SharedModule],
  templateUrl: './custom-warning.component.html',
  styleUrl: './custom-warning.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class CustomWarningComponent {
  @Input() public data?: CustomWarningConfig;
  @Output() public action = new EventEmitter<{ action: string; payload?: any }>();
  public isDntShowClicked = false;

  public onCancel() {
    this.action.emit({ action: 'CLOSE', payload: { isDntShowClicked: this.isDntShowClicked } });
  }

  public onConfirm() {
    this.action.emit({ action: 'CONFIRM', payload: { isDntShowClicked: this.isDntShowClicked } });
  }

  public onSecondConfirm() {
    this.action.emit({
      action: 'SECOND_CONFIRM',
      payload: { isDntShowClicked: this.isDntShowClicked },
    });
  }
}
